import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { zones } from 'services/zones';
import { notify } from 'libs/common';
import { Alert, Button, themes } from 'libs/ui';
import { Buttons, Content } from './zones-limit.styled';
import { LimitByZone } from './limit-by-zone';
import { LimitByTime } from './limit-by-time';
import { LimitByTimeMulti } from './limit-by-time-multi';

let colors;

export const ZonesLimit = (props) => {
  const { t } = useTranslation();

  const { clientId } = props;

  const [ready, setReady] = useState(false);
  // const [limits, setLimits] = useState([]);
  const [data, setData] = useState(null);
  const [nextrender, setNextrender] = useState(0);

  useEffect(() => {
    const getData = () => {
      api.call('clients.get_limits', { client_id: clientId }).then((data) => {
        colors = zones.getZonesColors();
        // const limits = data.map((el) => {
        //   return { ...el, color: colors[el.zone_id] };
        // });
        // console.log('🚀 ~ limits ~ limits:', limits);
        // setLimits(limits);
        setData(data);
        setReady(true);
      });
    };
    getData();
    return () => {
      setData(null);
      setReady(false);
    };
  }, []);

  /**
   * save limits
   */
  const save = () => {
    // console.log('🚀 ~ save ~ data:', data);
    const dataOk = data.map((el) => {
      const out = { ...el };
      if (out.zone_ids !== undefined) {
        delete out.zone_id;
      }
      return out;
    });

    api
      .call('clients.set_limits', { client_id: clientId, limits: dataOk })
      .then(() => {
        notify(t('messages.Лимиты ТС'), t('messages.Лимиты сохранены'), 'success');
      })
      .catch((error) => {
        // console.log('🚀 ~ save ~ error:', error);
        notify(t('messages.Лимиты ТС'), t('messages.Ошибка сохранения: ') + error.toString());
      });
  };

  const changeData = (out) => {
    setData(out);
    setNextrender((val) => val + 1);
  };

  if (!ready) {
    return null;
  }

  if (!data.length) {
    return <Alert>{t('messages.Данные по лимитам зон у клиента отсутствуют')}</Alert>;
  }

  const isByZone = data[0].start_time === undefined;
  const isByTimeOld = data[0].zone_ids === undefined;

  return (
    <Content>
      {isByZone ? (
        <LimitByZone colors={colors} onChange={changeData} data={data} nextrender={nextrender} />
      ) : isByTimeOld ? (
        <LimitByTime colors={colors} onChange={changeData} data={data} nextrender={nextrender} />
      ) : (
        <LimitByTimeMulti colors={colors} onChange={changeData} data={data} nextrender={nextrender} />
      )}

      <Buttons>
        <Button theme={themes.blue} onClick={save}>
          <i className="fa fa-save" />
          {t('buttons.Сохранить')}
        </Button>
      </Buttons>
    </Content>
  );
};
